import React from 'react'
import { ColorValue } from 'react-native'
import Svg, { LinearGradient as SvgLinearGradient, Rect, Stop } from 'react-native-svg'

interface Coord {
  x: number
  y: number
}

interface LinearGradientProps {
  style?: Svg['props']['style']

  /**
   * Color in format rgb or hex. Without opacity
   */
  startColor: ColorValue

  /**
   * Color in format rgb or hex. Without opacity
   */
  endColor: ColorValue

  startOpacity: number
  endOpacity: number
  middleColor?: ColorValue
  middleOpacity?: number
  start: Coord
  end: Coord
  startOffset?: number
  middleOffset?: number
  endOffset?: number
}

export const LinearGradient = ({
  start,
  end,
  startColor,
  endColor,
  startOpacity,
  endOpacity,
  middleColor,
  middleOpacity,
  style = {},
  startOffset = 0,
  middleOffset = 0.5,
  endOffset = 1,
}: LinearGradientProps) => {
  const [gradientX1, gradientY1, gradientX2, gradientY2] = [start.x, start.y, end.x, end.y].map(
    (coord) => (coord * 100).toString() + '%',
  )
  const hasMiddleStop = middleColor !== undefined && middleOpacity !== undefined
  const stops = [
    <Stop
      key="start"
      offset={`${startOffset * 100}%`}
      stopColor={startColor}
      stopOpacity={startOpacity}
    />,
    ...(hasMiddleStop
      ? [
          <Stop
            key="middle"
            offset={`${middleOffset * 100}%`}
            stopColor={middleColor}
            stopOpacity={middleOpacity}
          />,
        ]
      : []),
    <Stop key="end" offset={`${endOffset * 100}%`} stopColor={endColor} stopOpacity={endOpacity} />,
  ]

  return (
    <Svg style={style}>
      <SvgLinearGradient
        id="gradient"
        x1={gradientX1}
        y1={gradientY1}
        x2={gradientX2}
        y2={gradientY2}
      >
        {stops}
      </SvgLinearGradient>
      <Rect x="0" y="0" width="100%" height="100%" fill="url(#gradient)" />
    </Svg>
  )
}
